<template>
    <div class="ut">
        <div v-for="(column, columnIndex) in value.columns" :key="columnIndex"
             :class="`ut-column ut-column-${column.title} ut-column-${columnIndex}`"
             :style="getColumnStyle(columnIndex, column)">
            <div class="ut-column-header">
                <div class="ut-column-title" style="display: flex">
                    {{ column.title }}
                </div>
            </div>
            <div class="ut-column-body" style="display: flex; flex-direction: row">
                <div class="ut-paginator-list" v-if="isShowPaginator(column)">
                    <PaginatorItem v-for="item in countPage(column)"
                                   :active="isActive(columnIndex, item)"
                                   :key="`paginator-item-${item}`"
                                   :title="item"/>
                </div>
                <div class="ut-column-tickets" :style="isShowPaginator(column) ? 'padding-left: 0; padding-right: .6vw' :''">
                    <div v-for="(ticket, ticketIndex) in getTickets(columnIndex, column)" :key="ticketIndex"
                         class="ut-column-ticket" style="display: flex">
                        <div class="ticketNumber" v-text="ticket ? ticket.ticketNumber : ''"/>
                        <div v-if="ticket != null && isShowArrow(column)" class="arrow" style="display: flex">
                            <component :is="column.arrow"/>
                        </div>
                        <div v-if="column.showSeats" class="seatLabel" v-text="ticket ? ticket.seatLabel : ''"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import IconArrowShort from '@/components/Icons/IconArrowShort.vue'
import TableModel from '@/app/model/universal/Table.model'
import PaginatorList from '@/components/paginator/PaginatorList.vue'
import PaginatorItem from '@/components/paginator/PaginatorItem.vue'
import { mapState } from 'vuex'

const countTicketInColumn = 8
const TIMER = 1000

export default {
    name: 'UniversalTable',
    components: {
        PaginatorItem,
        PaginatorList,
        IconArrowShort
    },
    props: {
        value: {
            type: TableModel
        }
    },
    watch: {
        value () {
            if (this.value && this.value.columns) {
                this.value.columns
                    .forEach((col, colIndex) => {
                        if (col.showPaginator) {
                            this.startPagePaginator(colIndex, col)
                        }
                    })
            }
        }
    },
    data () {
        return {
            currentPageMap: {},
            currentPageIntervalMap: {}
        }
    },
    mounted () {
        if (this.value && this.value.columns) {
            this.value.columns
                .forEach((col, colIndex) => {
                    if (col.showPaginator) {
                        this.startPagePaginator(colIndex, col)
                    }
                })
        }
    },
    computed: {
        ...mapState({
            pageTimer: state => state.gui.settings.colorScheme.pageTimer
        })
    },
    methods: {
        startPagePaginator (columnIndex, column) {
            if (this.pageTimer > 0) {
                clearInterval(this.currentPageIntervalMap[columnIndex])
                this.$set(this.currentPageMap, columnIndex, 0)
                this.$set(this.currentPageIntervalMap, columnIndex, setInterval(() => {
                    if (this.getCurrentPageMap(columnIndex) < this.countPage(column) - 1) {
                        this.$set(this.currentPageMap, columnIndex, this.getCurrentPageMap(columnIndex) + 1)
                    } else {
                        this.$set(this.currentPageMap, columnIndex, 0)
                    }
                }, this.pageTimer * TIMER))
            }
        },
        isShowArrow (column) {
            return column.showSeats && column.arrow !== undefined
        },
        isShowPaginator (column) {
            return column.showPaginator && this.pageTimer > 0 && this.countPage(column) > 1
        },
        isActive (columnIndex, item) {
            return item - 1 === this.getCurrentPageMap(columnIndex)
        },
        getTickets (columnIndex, column) {
            const result = column.showPaginator
                ? column.tickets.slice(this.startTicketNumber(columnIndex, column), this.endTicketNumber(columnIndex, column))
                : column.tickets.slice(0, countTicketInColumn * column.innerColumnsCount)
            if (result.length < column.innerColumnsCount) {
                result.push(...Array(column.innerColumnsCount - result.length).fill(null))
            }
            return result
        },
        startTicketNumber (columnIndex, column) {
            return this.getCurrentPageMap(columnIndex) * countTicketInColumn * column.innerColumnsCount
        },
        endTicketNumber (columnIndex, column) {
            return (this.getCurrentPageMap(columnIndex) + 1) * countTicketInColumn * column.innerColumnsCount
        },
        getColumnStyle (columnIndex, column) {
            return Object.assign(column.style, {
                backgroundColor: `var(--ut-column-${columnIndex}-background)`,
                '--tickets-per-row': column.innerColumnsCount
            })
        },
        countPage (column) {
            return Math.ceil(column.tickets.length / (countTicketInColumn * column.innerColumnsCount))
        },
        getCurrentPageMap (columnIndex) {
            if (!this.currentPageMap[columnIndex]) {
                this.$set(this.currentPageMap, columnIndex, 0)
            }
            return this.currentPageMap[columnIndex]
        },
        beforeDestroy () {
            Object.values(this.currentPageIntervalMap).forEach(value => clearInterval(value))
        }
    }
}
</script>

<style>
.logo-img {
    height: var(--logo-size-height);
    width: var(--logo-size-width);
}
</style>
